import React, { useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 20px;
  .card-label {
    color: var(--text-primary);
  }
`;

const TitleWrapper = styled.div``;

const LatencyLabel = styled.div`
  border-radius: 4px;
  background: var(--signal-blue-light, #0095ff3d);
  color: var(--signal-blue, #006ab7);
  font-size: 13px !important;
  font-family: "AllianceNo2-SemiBold";
  font-weight: 100;
  font-style: normal;
  padding: 4px 6px 0px 6px;
  margin-top: -5px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const DBWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0;
`;

const DBEntry = styled.div`
  display: flex;
  align-items: flex-end;
  color: var(--Text-Primary) !important;
  &:hover {
  text-decoration: underline;
  cursor: pointer;
  }
  h2 {
    margin: 0;
    font-size: 28px !important;
    font-family: "AllianceNo2-SemiBold" !important;
    line-height: 91.5% !important;
    font-weight: 100 !important;
    padding-right: 5px;
  }
  h4 {
    margin: 0;
    font-size: 13px !important;
    font-family: "AllianceNo2-SemiBold" !important;
    line-height: 118.5% !important;
    color: var(--text-primary) !important;
  }
`;

const ProgressBarWrapper = styled.div`
  .card-label {
    color: var(--text-primary);
  }
`

const ProgressBar = ({ title, value, link }) => {
  const { view, params } = link;
  const handleClick = () => {
    globalNavigate(view, params);
  };

  return (
    <ProgressBarWrapper>
      <div>
        <div className="pull-left card-label">{title}</div>
        <div className="pull-right text-right">
          <div
            className="hyperlink-text-nocolor card-label"
            onClick={handleClick}
          >
            {value}
          </div>
        </div>
        <div className="clearfix"></div>
      </div>
      <div className="progress">
        <div
          className="progress-bar"
          role="progressbar"
          style={{ width: value.replace(/\s+/, "") }}
        ></div>
      </div>
    </ProgressBarWrapper>
  );
};

const DownUpLink = ({
  title,
  shaping,
  shapingLink,
  rate,
  rateLink,
  latency,
  latencyLink,
  dbRate,
  dbRateLink,
  dbPpsValue,
  dbPpsUnit,
  dbPpsLink
}) => {
  const [dbRateValue, dbRateUnit] = dbRate.split(" ");
  const latencyLabel = title === "Downlink" ? "Access latency" : "Internet Latency";
  return (
    <div className="card">
      <Wrapper>
        <TitleWrapper>
          <h4 className="card-title">{title}</h4>
        </TitleWrapper>
        <DBWrapper>
          <DBEntry onClick={()=> globalNavigate(dbRateLink.view, dbRateLink.params)}>
            <h2>{dbRateValue}</h2>
            <h4>{dbRateUnit}</h4>
          </DBEntry>
          <DBEntry onClick={()=>globalNavigate(dbPpsLink)}>
            <h2>{dbPpsValue}</h2>
            <h4>{dbPpsUnit}</h4>
          </DBEntry>
        </DBWrapper>
        <ProgressBar
          title={"Shaping Percentage"}
          value={shaping}
          link={shapingLink}
        />
        <ProgressBar
          title={"Rate-limit Percentage"}
          value={rate}
          link={rateLink}
        />

        <div>
          <div className="pull-left card-label">{latencyLabel}</div>
          <div className="pull-right text-right">
            <LatencyLabel onClick={() => globalNavigate(latencyLink)}>
              {latency}
            </LatencyLabel>
          </div>
          <div className="clearfix"></div>
        </div>
      </Wrapper>
    </div>
  );
};
export default DownUpLink;
